import React from "react";

function SimplePage({ title, description }) {
  return (
    <main className="section">
      <div className="container">
        <h1 className="section-title">{title}</h1>
        <p style={{ maxWidth: "640px", color: "#777", fontSize: "14px" }}>
          {description ||
            "This page will be designed later. The navigation and routing are already in place so you can plug in the final layout when it is ready."}
        </p>
      </div>
    </main>
  );
}

export default SimplePage;

